import { v4 as uuidv4 } from "uuid";
import axiosInstance from "../../../../../axiosInstance";
import history from "../../../../../history";
import {
  error,
  info,
  success,
  warning,
} from "../../../../../store/notification/actions";
import { SendSignUpSuccessMail } from "../../../SignUp/helper/signUpHelper";

export async function ActiveUser(data) {
  if (data != null) {
    if (
      !data.firstName ||
      !data.lastName ||
      !data.displayName ||
      !data.email ||
      !data.password ||
      !data.stores ||
      !data.roles
    ) {
      error("Please enter Required Field");
      return {
        message: "Please enter Required Field",
        hasError: true,
        data: "",
      };
    }
    return await axiosInstance
      .post("/activeuser/submitActiveUser", {
        first_name: data.firstName,
        displayname: data.displayname,
        last_name: data.lastName,
        user_emailid: data.email,
        password: data.password,
        street1: data.street1,
        street2: data.street2 ? data.street2 : "",
        store_ids: data.stores.join(),
        role_id: data.roles,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success(
            "User account successfully created UserName : " +
              response.data.data.messages
          );
          history.push("/signIn");
          return { message: "", hasError: false, data: "" };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

export async function GetRole() {
  return await axiosInstance
    .get("/activeuser/getRole")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.role_id,
          rolename: obj.rolename,
          roletype: obj.usertype,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetEmployeeDropDownData(params) {
  return await axiosInstance
    .get("/common/GetStates", {
      params: params,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.state_id,
          optionname: obj.state_name,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetRoleDropDownData(params) {
  return await axiosInstance
    .get("/common/GetCities", {
      params: params,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.city_id,
          optionname: obj.city_name,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetStoreEmployeesEmail(storeId) {
  return await axiosInstance
    .get("/employee/getStoreEmployeesEmail", {
      params: { store_id: storeId },
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetEmployeeDetails(user_emailid, store_id) {
  return await axiosInstance
    .get("/employee/getEmployeeDetails", {
      params: { user_emailid, store_id },
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function VerifyUniqueUserEmail(user_emailid) {
  return await axiosInstance
    .get("/employee/verifyUniqueUserEmail", {
      params: { user_emailid: user_emailid },
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function GetStoresUserLicense(stores) {
  return await axiosInstance
    .post("/store/getStoresUserLicense", {
      stores,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export function AddActiveUser(activeUser) {
  const password = activeUser.autogeneratepassword
    ? uuidv4()
    : activeUser.userpassword;
  return axiosInstance
    .post("/activeUser/addActiveUser", {
      first_name: activeUser.firstname,
      last_name: activeUser.lastname,
      user_email: activeUser.emailid,
      password,
      roles: JSON.stringify(
        activeUser.roles.map((role) => ({
          RolePK: role.id,
          StorePK: role.storepk,
        }))
      ),
    })
    .then(async (response) => {
      if (response && response.data && response.data.status === "success") {
        const emailSent = await SendSignUpSuccessMail({
          user_email: activeUser.emailid,
          user_name: response.data.data[0].userid,
          password,
        });
        if (!emailSent) error("Email Not Sent!!!");
        success("Added New User Successfully!!!");
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {
      error("Failed to add User!!!");
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
}

export async function getActiveUsers(user) {
  info("Loading Active Users...");
  return await axiosInstance
    .get(`/activeUser/getActiveUsers/${user}`)
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        success("Loaded Active Users Successfully!!!");
        return response.data;
      } else {
        warning("No records found !!!.")
        return "";
      }
    })
    .catch((err) => {
      error("Failed to Load ActiveUsers!!!");
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
}

export async function deleteActiveUser(userid) {
  return await axiosInstance
    .post(`/activeUser/deleteActiveUser`, { user_id: userid })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        success("Deleted User Successfully!!!");
        return response.data;
      } else {
        return "";
      }
    })
    .catch((err) => {
      error("Failed to Delete User!!!");
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
}

export async function editActiveUser(activeUser) {
  return await axiosInstance
    .post(`/activeUser/editActiveUser`, {
      main_user: activeUser.mainUser,
      first_name: activeUser.firstname,
      last_name: activeUser.lastname,
      email: activeUser.useremailid,
      user_id: activeUser.userid,
      roles: JSON.stringify(
        activeUser.roles.map((role) => ({
          RolePK: role.role_pk,
          StorePK: role.store_pk,
        }))
      ),
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        success("Updated User Successfully!!!");
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {
      error("Failed to Update User!!!");
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
}
